import{a as i,d as m}from"./chunk-FYW7X4VG.js";import{b as t,c as e}from"./chunk-4SX6RUNR.js";import{a as n}from"./chunk-NRGC2OZ2.js";import{m as o}from"./chunk-HBP5N4FR.js";o();e();m();n();function a(r){i.dispatch(t({address:r,loginMethod:"extra"}))}export{a};
//# sourceMappingURL=chunk-KFH3JURQ.js.map
